import { render, staticRenderFns } from "./SectionCallToAction.vue?vue&type=template&id=c60084dc&"
import script from "./SectionCallToAction.vue?vue&type=script&lang=js&"
export * from "./SectionCallToAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports